import Form from '../../../../form_builder_2/form';
import AnalyticsHelper from '../../../../utils/analytics-helper';

export default class PasswordResetView {
    constructor(parent) {
        this.parent = parent;
        this.el = parent.el.querySelector('.password-reset-view');
        this.form = new Form(this.parent.el.querySelector('.password-reset-form'), {
            onSuccess: this.onSuccess.bind(this),
            onError: this.onError.bind(this),
        });
    }

    onSuccess(result) {
        if (this.parent.params.password) {
            window.HONDA?.MyAccount2?.logout();
            this.parent.show({ view: 'password-reset-success' });
        } else {
            this.parent.show({ view: 'login' });
        }

        this.analyticsPush();
    }

    onError(result) {
        if (result?.token === false) {
            this.parent.show({ view: 'password-send-otp', message: this.el.dataset.otpExpiredError });
        } else {
            this.form.showError();
        }
    }

    show() {
        this.el.classList.remove('hide');
    }

    hide() {
        this.el.classList.add('hide');
    }

    back() {
        this.parent.show({ view: 'password-validate-otp' });
    }

    analyticsPush() {
        AnalyticsHelper.push({
            event:'my_account',
            eventCategory:'my account',
            eventAction:'reset password submit',
            eventLabel:`${dataLayer[0].productCategory}|My account|submit|internal|#`,
            actionType:'reset password submit',
            businessUnit : dataLayer[0].productCategory,
            moduleName:'My account',
            clickText:'submit',
            clickType:'internal', 
            destinationURL:'#',
        });
    }
}
